<template>
  <div id="checkin" class="screen">

    <div class="section">
      <div class="overview mx-3" v-if="viewedPresentation.title">
        <h1 class="display-1 mb-3">{{viewedPresentation.title}}</h1>

        <div class="mb-1" v-if="viewedPresentationDate">
          <v-icon>date_range</v-icon>
          <span>{{viewedPresentationDate}}</span>
        </div>

        <div class="mb-1">
          <v-icon>person</v-icon>
          <span>{{viewedPresentation.attendeeCount}}</span>
        </div>

        <div class="mb-1" v-if="rating">
          <v-icon>star</v-icon>
          <span>{{rating}} out of 5 ({{numberOfRatings}} ratings)</span>
        </div>

        <div class="mb-1" @click="toggleCommentsModal">
          <v-icon>mode_comment</v-icon>
          <span>{{comments.length}}</span>
        </div>
      </div>

      <div class="slides-list">
        <div v-for="slide in viewedPresentation.slides" :key="slide.image">
          <v-card class="slide mx-3 mt-3">
            <v-img :src="slide.image"></v-img>
          </v-card>
          <div class="mx-3">
            <v-btn text icon>
              <v-icon>star</v-icon>
              <span class="fav-label">{{slide.favorited || 0}}</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-model="showCommentModal" fullscreen>
      <v-card>
        <v-card-title class="headline">
          Comments
          <v-spacer></v-spacer>
          <v-btn icon @click="toggleCommentsModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div v-for="feedback in viewedPresentationFeedback" v-if="feedback.comment !== ''"
             :key="feedback.comment" class="mt-3">
            <p>{{feedback.comment}}</p>
            <v-divider></v-divider>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Presentation',

  created() {
    this.$store.dispatch('viewPresentation', this.$route.params.presentationId);
  },

  data: () => ({
    showCommentModal: false
  }),

  computed: {
    comments() {
      return this.viewedPresentationFeedback
        ? this.viewedPresentationFeedback.filter(feedback => feedback.comment !== '')
        : 0;
    },
    numberOfRatings() {
      return this.viewedPresentationFeedback
        ? this.viewedPresentationFeedback.filter(feedback => feedback.rating > 0).length
        : null;
    },
    rating() {
      let ratingTotal = 0;
      let numberOfRatings = 0;

      if (!this.viewedPresentationFeedback) {
        return null;
      }

      if (this.viewedPresentationFeedback.length === 0) {
        return '0';
      }

      this.viewedPresentationFeedback.forEach((feedback) => {
        if (feedback.rating > 0) {
          ratingTotal += feedback.rating;
          numberOfRatings += 1;
        }
      });

      return (ratingTotal / numberOfRatings).toFixed(1);
    },
    viewedPresentationDate() {
      return this.viewedPresentation.presentationDate ? this.viewedPresentation.presentationDate.toDate().toLocaleDateString() : '';
    },
    ...mapGetters([
      'viewedPresentation',
      'viewedPresentationFeedback'
    ])
  },

  methods: {
    toggleCommentsModal() {
      this.showCommentModal = !this.showCommentModal;
    }
  }
};
</script>

<style lang="scss" scoped>
  .slide {
    min-height: 172px;
    background-color: #fff;
  }

  .fav-label {
    line-height: 24px;
  }

  .stat .box {
    min-height: 100px;
  }

  .graph .heading {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Presented.vue